module.exports = __webpack_public_path__ + "static/media/turbo.d7240a87.svg";